<template>
  <div id="app" class="disableSelect">
    <router-view/>

    <canvas id="canvas" width="240" height="180" style="position: absolute; right: -1000px; top: -1000px"></canvas>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@import (css) url('https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,700,700i,900&display=swap&subset=latin-ext');
@import url('./assets/style.less');
.disableSelect{
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue